import {Controller} from "stimulus"
import $ from 'jquery';
import {get, post} from "@rails/request.js";
import bootbox from "bootbox";
import toastr from "toastr";
import {validate_email} from "./validate_controller";
import {blockElementsById, unBlockElementById} from "./blockUI_controller";
import {Spanish} from "flatpickr/dist/l10n/es";
import {english} from "flatpickr/dist/l10n/default";
import {set_locale} from "./localize_controller";

let flatpick_lang;

export default class extends Controller {
    static targets = [
        "inputPaymentMethod", "extraFincimex", "extraCash", "extraTm", "extraEnz", "currencyCash", "noTransTm",
        "noTransEnz", "importeCash", "importeTm", "importeEnz", "numRooms", "roomsContainer", "submitButton",
        "hotelSelect", "dateRange", "addRoomToVirtualCard", "completeBooking", "rateFilter", "roomOptionsContainer", "priceSort",
        // NUEVOS TARGETS
        "locationRegion", "locationArea", "locationZone",
        // Cadena
        "vendorCode"
    ]

    connect() {
        // Guard: skip connect when element has data-connect="false"
        if (this.element.dataset.connect === "false") {
            return
        }

        set_locale().then(
            locale => {
                switch (I18n.locale) {
                    case 'es':
                        flatpick_lang = Spanish;
                        break;
                    case 'en':
                        flatpick_lang = english;
                        break;
                }
                if (this.element.dataset.connect) {
                    return;
                }

                this.generateRooms()
                this.validateForm()

                $('#date_range_separator').val(flatpick_lang.rangeSeparator);
                $('#page_referer').val(`${window.location.href}${window.location.pathname}${window.location.search}`);
            })

        let context = this;
        if (this.hasHotelSelectTarget && this.hasSubmitButtonTarget) {
            $(this.hotelSelectTarget).on('select2:unselecting', function () {
                context.submitButtonTarget.disabled = true;
            })
        }
        if (this.hasVendorCodeTarget) {
            $(this.vendorCodeTarget).on('select2:unselecting', function () {
                context.loadHotelsByLocation();
            })
        }
        if (this.hasLocationRegionTarget) {
            $(this.locationRegionTarget).on('select2:unselecting', function () {
                context.loadHotelsByLocation();
                context.loadAreas();
                context.loadZones();
            })
        }
        if (this.hasLocationAreaTarget) {
            $(this.locationAreaTarget).on('select2:unselecting', function () {
                context.loadHotelsByLocation();
                context.loadAreas();
                context.loadZones();
            })
        }
        if (this.hasLocationZoneTarget) {
            $(this.locationZoneTarget).on('select2:unselecting', function () {
                context.loadHotelsByLocation();
                context.loadAreas();
                context.loadZones();
            })
        }
    }

    selectPaymentMethod(event) {
        const selectedValue = event.target.value;
        console.log("Seleccionado:", selectedValue);

        if (selectedValue === "fincimex") {
            this.extraFincimexTarget.classList.remove("hide-tooltip");
            this.extraCashTarget.classList.add("hide-tooltip");
            this.extraTmTarget.classList.add("hide-tooltip");
            this.extraEnzTarget.classList.add("hide-tooltip");
        } else if (selectedValue === "cash") {
            this.extraCashTarget.classList.remove("hide-tooltip");
            this.extraFincimexTarget.classList.add("hide-tooltip");
            this.extraTmTarget.classList.add("hide-tooltip");
            this.extraEnzTarget.classList.add("hide-tooltip");
        } else if (selectedValue === "tm") {
            this.extraCashTarget.classList.add("hide-tooltip");
            this.extraFincimexTarget.classList.add("hide-tooltip");
            this.extraTmTarget.classList.remove("hide-tooltip");
            this.extraEnzTarget.classList.add("hide-tooltip");
        } else if (selectedValue === "enz") {
            this.extraCashTarget.classList.add("hide-tooltip");
            this.extraFincimexTarget.classList.add("hide-tooltip");
            this.extraTmTarget.classList.add("hide-tooltip");
            this.extraEnzTarget.classList.remove("hide-tooltip");
        } else {
            this.extraFincimexTarget.classList.add("hide-tooltip");
            this.extraCashTarget.classList.add("hide-tooltip");
            this.completeBookingTarget.classList.remove("disabled");
        }
    }

    get selectedRadioPaymentMethod() {
        const checked = this.inputPaymentMethodTargets.find(radio => radio.checked)
        return checked ? checked.value : null
    }

    validateInputTmEnzPayment(event) {
        const input = event.target
        const ph = input.placeholder.toLowerCase()
        let raw = input.value

        // --- Genérico obligatorio (*): no vacío ---
        if (ph.trim().startsWith("*")) {
            const ok = input.value.trim() !== ""
            this._markValidity(input, ok)
            return this.toggleButton()
        }

        // Campos opcionales: nunca inválidos (solo limpiar clases)
        this._markValidity(input, true, true)
        this.toggleButton()
    }

    validateInputPayment(event) {
        const input = event.target
        const ph = input.placeholder.toLowerCase()
        let raw = input.value

        // Correo electrónico (async)
        if (ph.includes("correo")) {
            validate_email(raw).then(success => {
                if (success) {
                    input.classList.remove("is-invalid")
                    input.classList.add("is-valid")
                } else {
                    input.classList.add("is-invalid")
                    input.classList.remove("is-valid")
                }
                this.toggleButton() // actualizar el botón después de la validación async
            })
            return // ⬅️ IMPORTANTE: salimos aquí porque la validación es async
        }

        // --- IMPORTE: solo dígitos con decimales opcionales (. o ,), máx 2 decimales ---
        if (ph.includes("importe")) {
            raw = raw.replace(/,/g, ".").slice(0, 10)
            // Permite teclear progresivamente: "","1","1.","1.2","1.23"
            // Todo lo demás lo recorta
            const match = raw.match(/^\d*(?:\.\d{0,2})?$/)
            if (!match) {
                // borra el último char inválido
                raw = raw.slice(0, -1)
            }
            input.value = raw
            this._markValidity(input, raw !== "" && /^\d+(?:\.\d{1,2})?$/.test(raw))
            return this.toggleButton()
        }

        // Moneda con select
        if (ph.includes("moneda") || input.name === "currency") {
            if (!value) {
                input.classList.add("is-invalid")
                input.classList.remove("is-valid")
            } else {
                input.classList.remove("is-invalid")
                input.classList.add("is-valid")
            }
            this.toggleButton()
            return
        }

        // --- FECHA: dd/mm/yyyy con máscara y rangos parciales ---
        if (ph.includes("fecha")) {
            let d = raw.replace(/\D/g, "").slice(0, 8) // solo dígitos, máx 8 (ddmmyyyy)

            // validación parcial por pasos (evita cosas tipo 40/99/____)
            if (d.length >= 1 && parseInt(d[0], 10) > 3) d = d.slice(0, -1)
            if (d.length >= 2) {
                const day = parseInt(d.slice(0, 2), 10)
                if (day === 0 || day > 31) d = d.slice(0, -1)
            }
            if (d.length >= 3 && parseInt(d[2], 10) > 1) d = d.slice(0, -1)
            if (d.length >= 4) {
                const month = parseInt(d.slice(2, 4), 10)
                if (month === 0 || month > 12) d = d.slice(0, -1)
            }

            // Formatear máscara
            let formatted = d
            if (d.length > 2) formatted = d.slice(0, 2) + "/" + d.slice(2)
            if (d.length > 4) formatted = d.slice(0, 2) + "/" + d.slice(2, 4) + "/" + d.slice(4)
            input.value = formatted

            // Validez final: cuando tiene 8 dígitos, confirmar fecha real (incluye feb/leap)
            let ok = false
            if (d.length === 8) {
                const day = parseInt(d.slice(0, 2), 10)
                const month = parseInt(d.slice(2, 4), 10)
                const year = parseInt(d.slice(4), 10)
                ok = this._isValidDateDMY(day, month, year)
            }

            // ← AÑADIR ESTO justo antes del return:
            this._updateMaskHint(input, formatted, "dd/mm/yyyy")

            this._markValidity(input, ok)
            return this.toggleButton()
        }

        // --- HORA: hh:mm:ss con máscara y rangos ---
        if (ph.includes("hora")) {
            let t = raw.replace(/\D/g, "").slice(0, 6)

            if (t.length >= 1 && parseInt(t[0], 10) > 2) t = t.slice(0, -1)
            if (t.length >= 2) {
                const hh = parseInt(t.slice(0, 2), 10)
                if (hh > 23) t = t.slice(0, -1)
            }
            if (t.length >= 3 && parseInt(t[2], 10) > 5) t = t.slice(0, -1)
            if (t.length >= 4) {
                const mm = parseInt(t.slice(2, 4), 10)
                if (mm > 59) t = t.slice(0, -1)
            }
            if (t.length >= 5 && parseInt(t[4], 10) > 5) t = t.slice(0, -1)
            if (t.length >= 6) {
                const ss = parseInt(t.slice(4, 6), 10)
                if (ss > 59) t = t.slice(0, -1)
            }

            // ← NUEVO: autocompletar :00 cuando se tienen hh:mm completos (4 dígitos)
            // solo en evento blur, o si el usuario ya no está escribiendo los segundos
            const isBlur = event.type === "blur"
            let tDisplay = t
            if (t.length === 4 && isBlur) {
                tDisplay = t + "00"  // autocompletar segundos en :00
                t = tDisplay
            }

            let formatted = t
            if (t.length > 4) {
                formatted = t.slice(0, 2) + ":" + t.slice(2, 4) + ":" + t.slice(4)
            } else if (t.length > 2) {
                formatted = t.slice(0, 2) + ":" + t.slice(2)
            }

            if (input.value !== formatted) input.value = formatted

            this._updateMaskHint(input, formatted, "hh:mm:ss")

            const ok = t.length === 6
            this._markValidity(input, ok)
            return this.toggleButton()
        }

        // --- Genérico obligatorio (*): no vacío ---
        if (ph.trim().startsWith("*")) {
            const ok = input.value.trim() !== ""
            this._markValidity(input, ok)
            return this.toggleButton()
        }

        // Campos opcionales: nunca inválidos (solo limpiar clases)
        this._markValidity(input, true, true)
        this.toggleButton()
    }

    _updateMaskHint(input, value, mask) {
        const hint = input.parentElement.querySelector(".input-mask-hint")
        if (!hint) return

        if (!value || value.length === 0) {
            hint.textContent = ""
            return
        }

        // La parte ya escrita se vuelve invisible (espacios),
        // la parte restante de la máscara se muestra en gris
        const written = value.length
        const ghost = "\u00A0".repeat(written) + mask.slice(written)
        hint.textContent = ghost
    }

    // Helpers dentro del mismo controller:
    _markValidity(input, ok, optional = false) {
        if (ok) {
            input.classList.add("is-valid")
            input.classList.remove("is-invalid")
        } else {
            // Si es opcional y vacío, no lo marques inválido
            if (optional && input.value.trim() === "") {
                input.classList.remove("is-invalid", "is-valid")
                return
            }
            input.classList.add("is-invalid")
            input.classList.remove("is-valid")
        }
    }

    _isValidDateDMY(d, m, y) {
        const date = new Date(y, m - 1, d)
        // Puedes añadir límites si quieres, p. ej. año razonable:
        if (y < 1900 || y > 2100) return false
        return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d
    }

    toggleButton() {
        const paymentMethod = this.selectedRadioPaymentMethod; // 'fincimex', 'tm' o 'enz'

        // Mapeo de método de pago -> target correspondiente
        const targetMap = {
            fincimex: this.extraFincimexTarget,
            tm: this.extraTmTarget,
            enz: this.extraEnzTarget
        }

        // Obtener solo los inputs del método seleccionado
        const container = targetMap[paymentMethod]
        const allRequiredInputs = container ?
            Array.from(container.querySelectorAll("input")).filter(input =>
                input.placeholder.trim().startsWith("*") || input.classList.contains("required")
            ) : []

        // Validación
        const hasInvalid = allRequiredInputs.some(input =>
            !input.value.trim() || input.classList.contains("is-invalid")
        )

        this.completeBookingTarget.classList.toggle("disabled", hasInvalid)
    }


    // Si quieres obtener todos los valores válidos cuando lo necesites
    getExtraInputs() {
        const paymentMethod = this.selectedRadioPaymentMethod; // 'fincimex', 'tm' o 'enz'

        const opcion2 = document.querySelector(`input[name="opcionPaymentMethod"][value="${paymentMethod}"]`)
        if (!opcion2 || !opcion2.checked) return null

        // Mapeo de método de pago -> target correspondiente
        const targetMap = {
            fincimex: this.extraFincimexTarget,
            tm: this.extraTmTarget,
            enz: this.extraEnzTarget
        }

        // Obtener el contenedor activo según el método de pago
        const activeContainer = targetMap[paymentMethod]
        if (!activeContainer) return null // Seguridad por si el target no existe

        // IMPORTANT: incluir selects además de inputs
        const nodes = activeContainer.querySelectorAll("input, select, textarea")
        let valores = {}
        let valid = true

        for (const el of nodes) {
            const rawLabel = (el.placeholder || el.name || el.dataset.label || "").toString()
            const valueRaw = (el.value || "").toString().trim()
            const key = this._normalizeKey(rawLabel.replace("*", "").trim())

            const isRequired = (rawLabel && rawLabel.trim().startsWith("*")) ||
                el.classList.contains("required") ||
                el.required

            // required vacío
            if (isRequired && !valueRaw) {
                el.classList.add("is-invalid")
                el.classList.remove("is-valid")
                valid = false
                continue
            }

            // CORREO (async): validar y marcar
            if (key.includes("correo") && valueRaw) {
                // Normalizar correo: los emails no admiten espacios.
                // IMPORTANTE: se usa regex GLOBAL (\s+/g) para eliminar TODOS los
                // espacios. replace(' ', '') o replace(/\s/, '') solo eliminarían
                // la primera ocurrencia y dejarían el resto.
                const emailNormalizado = valueRaw.replace(/\s+/g, '')
                try {
                    const ok = validate_email(emailNormalizado) // tu función externa
                    if (!ok) {
                        el.classList.add("is-invalid")
                        el.classList.remove("is-valid")
                        valid = false
                        continue
                    } else {
                        el.classList.remove("is-invalid")
                        el.classList.add("is-valid")
                        valores[key] = emailNormalizado
                        continue
                    }
                } catch (err) {
                    // si la validación externa falla por red, marcar inválido
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
            }

            // IMPORTE: normalizar coma -> punto y validar decimales (0-2)
            if (key.includes("importe") && valueRaw) {
                const normalized = valueRaw.replace(",", ".")
                if (!/^\d+(\.\d{1,2})?$/.test(normalized)) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.value = normalized
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = normalized
                continue
            }

            // MONEDA: puede venir como select (name 'currency') o label 'moneda'
            if (key.includes("moneda") || key.includes("currency") || (el.tagName === "SELECT" && (el.name || "").toLowerCase().includes("currency"))) {
                if (!valueRaw) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
                continue
            }

            // FECHA: formato y validez real
            if (key.includes("fecha") && valueRaw) {
                const match = valueRaw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
                if (!match || !this._isValidDateDMY(+match[1], +match[2], +match[3])) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
                continue
            }

            // HORA: hh:mm:ss y rangos
            if (key.includes("hora") && valueRaw) {
                const match = valueRaw.match(/^(\d{2}):(\d{2}):(\d{2})$/)
                if (!match) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                const hh = parseInt(match[1], 10), mm = parseInt(match[2], 10), ss = parseInt(match[3], 10)
                if (hh > 23 || mm > 59 || ss > 59) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
                continue
            }

            // Por defecto: si tiene valor, lo guardo; si no, lo pongo null (si no es required)
            if (valueRaw) {
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
            } else {
                el.classList.remove("is-invalid")
                el.classList.remove("is-valid")
                valores[key] = null
            }
        } // end for

        if (!valid) {
            console.warn("Errores en campos obligatorios o con formato inválido")
            return null
        }

        return valores
    }

    // 🔹 Helper para normalizar claves
    _normalizeKey(key) {
        return key
            .normalize("NFD")                 // separa letras y acentos
            .replace(/[\u0300-\u036f]/g, "")  // elimina acentos
            .replace(/[^a-zA-Z0-9_]/g, "_")   // reemplaza lo raro por "_"
            .replace(/_+/g, "_")              // compacta "__" → "_"
            .replace(/^_+|_+$/g, "")          // quita "_" al inicio o final
            .toLowerCase()
    }

    generateRooms() {
        const desiredCount = parseInt(this.numRoomsTarget.value || "1")
        const currentCount = this.roomsContainerTarget.querySelectorAll(".room-card").length

        if (desiredCount > currentCount) {
            for (let i = currentCount; i < desiredCount; i++) {
                this.addRoom(i)
            }
        } else if (desiredCount < currentCount) {
            const allCards = this.roomsContainerTarget.querySelectorAll(".room-card")
            for (let i = currentCount - 1; i >= desiredCount; i--) {
                allCards[i].remove()
            }
        }

        this.validateForm()
    }

    addRoom(index) {
        const wrapper = document.createElement("div")
        /*wrapper.className = "card p-3 m-3 room-card col-2"*/
        wrapper.className = "card p-3 mt-3 room-card col-12 col-sm-6 col-lg-4 col-xl-3"
        // wrapper.className = "card p-3 mt-3 room-card col-12"
        wrapper.innerHTML = `
            <h5>Habitación ${index + 1}</h5>
            <div class="mb-2">
              <label for="rooms_${index}_num_guests">Personas:</label>
              <input type="number"
                     id="rooms_${index}_num_guests"
                     name="rooms[${index}][num_guests]"
                     min="1"
                     max="10"
                     value="1"
                     class="form-control mb-2 guest-count"
                     data-action="input->hotetec#updateGuestAges"
                     data-room-index="${index}">
            </div>
            <div class="ages-container" id="ages-room-${index}"></div>
          `
        this.roomsContainerTarget.appendChild(wrapper)

        this.buildAgeInputs(index, 1)
        this.validateForm()
    }

    updateGuestAges(event) {
        const roomIndex = event.target.dataset.roomIndex
        const newCount = parseInt(event.target.value || "0")
        const container = document.getElementById(`ages-room-${roomIndex}`)

        const oldValues = Array.from(container.querySelectorAll("input")).map(input => input.value)

        container.innerHTML = ""

        for (let i = 0; i < newCount; i++) {
            const input = document.createElement("input")
            input.type = "number"
            input.name = `rooms[${roomIndex}][guests][]`
            input.placeholder = `Edad persona ${i + 1}`
            input.min = 0
            input.className = "form-control mb-2"
            input.value = oldValues[i] || "30"

            input.addEventListener("keypress", this.blockNonNumeric)
            input.addEventListener("input", () => this.validateForm())

            container.appendChild(input)
        }

        this.validateForm()
    }

    buildAgeInputs(roomIndex, count) {
        const container = document.getElementById(`ages-room-${roomIndex}`)
        container.innerHTML = ""

        for (let i = 0; i < count; i++) {
            const input = document.createElement("input")
            input.type = "number"
            input.name = `rooms[${roomIndex}][guests][]`
            input.placeholder = `Edad persona ${i + 1}`
            input.min = 0
            input.className = "form-control mb-2"
            input.value = "30"

            input.addEventListener("keypress", this.blockNonNumeric)
            input.addEventListener("input", () => this.validateForm())

            container.appendChild(input)
        }
    }

    blockNonNumeric(event) {
        const charCode = event.charCode
        if (charCode < 48 || charCode > 57) {
            event.preventDefault()
        }
    }

    validateForm() {
        const hotelSelected = this.hasHotelSelectTarget && this.hotelSelectTarget.value.trim() !== ""
        const dateSelected = this.hasDateRangeTarget && this.dateRangeTarget.value.trim() !== ""

        const ageInputs = this.roomsContainerTarget.querySelectorAll("input[name*='guests']")
        let allValid = hotelSelected && dateSelected

        ageInputs.forEach(input => {
            const value = input.value.trim()
            const isValid = value !== "" && !isNaN(value) && Number(value) >= 0 && Number(value) < 150

            if (!isValid) {
                input.classList.add("is-invalid")
                input.classList.remove("is-valid")
                allValid = false
            } else {
                input.classList.remove("is-invalid")
                input.classList.add("is-valid")
            }
        })

        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = !allValid
        }
    }

    /* Agregar Habitación al Carrito virtual */
    book_room(e) {
        blockElementsById('resultSearchAvailability',
            `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                    </svg>
                    Agregando Habitación
                    </h4></div> `,
            'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');

        let rate_code = e.target.dataset.rate_code;
        let room_code = e.target.dataset.room_code;
        let meal_plan_code = e.target.dataset.meal_plan_code;
        let occupancy_code = e.target.dataset.occupancy_code;
        let dist = e.target.dataset.dist;
        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;

        $(`#${target}`).html(`<div style="height: 250px"></div>`);

        /* El beforeSend se maneja manualmente */
        const beforeSend = () => {
            console.log('Antes del envío');
            $(`#div-my-virtual-card`).addClass(`mb-3`);
            $(`#my-virtual-card`).addClass(`card card-body`);
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shopping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                    </svg>
                    ${target_message}
                    </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
        };

        beforeSend();
        post(`/admin/hotel/add_room_to_virtual_card`, {
            query: {
                rate_code: rate_code,
                room_code: room_code,
                meal_plan_code: meal_plan_code,
                occupancy_code: occupancy_code,
                dist: dist,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            /*this.isLogin(r);
            this.setDealerData()*/
            console.log("Room added to virtual card successfully");
            unBlockElementById('resultSearchAvailability');
        });
    }

    remove_book_room(e) {
        let bookedroomid = e.target.dataset.bookedroomid;
        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;

        bootbox.confirm({
            title: "Remover habitación",
            message: "¿Seguro que desea remover la habitación?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'medium',
            callback: function (result) {
                if (result) {
                    $(`#${target}`).html(`<div style="height: 250px"></div>`);

                    /* El beforeSend se maneja manualmente */
                    const beforeSend = () => {
                        console.log('Antes del envío');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shopping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                                </svg>
                                ${target_message}
                                </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
                    };

                    beforeSend();
                    post(`/admin/hotel/remove_room_to_virtual_card`, {
                        query: {
                            bookedroomid: bookedroomid,
                            target: target
                        },
                        responseKind: "turbo-stream"
                    }).then(r => {
                        /*this.isLogin(r);
                        this.setDealerData()*/
                        console.log("Habitación Removida");
                    });
                }
            }
        })
    }

    complete_booking(e) {
        const paymentMethod = this.selectedRadioPaymentMethod;
        const extraInputsFincimex = this.getExtraInputs();
        let currency_cash = this.currencyCashTarget.value;
        let importe_cash = this.importeCashTarget.value;   // opcional
        let no_trans_tm = this.noTransTmTarget.value;
        let importe_tm = this.importeTmTarget.value;        // obligatorio para TM
        let no_trans_enz = this.noTransEnzTarget.value;
        let importe_enz = this.importeEnzTarget.value;      // obligatorio para ENZ
        let guestCount = e.target.dataset.guest;
        let roomsCount = e.target.dataset.rooms;
        let url_go = e.target.dataset.urlgo;

        if (paymentMethod === 'fincimex') {
            this.toggleButton();

            if (!extraInputsFincimex) {
                console.warn("No se puede completar la reserva ya que faltan datos del pago mediante FINCIMEX.");
                toastr.error("No se puede completar la reserva ya que faltan datos del pago mediante FINCIMEX.");
                return
            }
        } else if (paymentMethod === 'cash') {
            if (currency_cash === '' || currency_cash === undefined) {
                toastr.error("No se puede completar la reserva ya que falta la moneda del pago mediante Efectivo.");
                return
            }
            if (importe_cash === '' || importe_cash === undefined || !/^\d+(\.\d{1,2})?$/.test(importe_cash)) {
                toastr.error("No se puede completar la reserva ya que falta o es inválido el importe del pago en Efectivo.");
                return
            }
        } else if (paymentMethod === 'tm') {
            this.toggleButton();
            if (no_trans_tm === '' || no_trans_tm === undefined) {
                toastr.error("No se puede completar la reserva ya que falta el No. Transacción mediante Transfermóvil.");
                return
            }
            if (importe_tm === '' || importe_tm === undefined || !/^\d+(\.\d{1,2})?$/.test(importe_tm)) {
                toastr.error("No se puede completar la reserva ya que falta o es inválido el importe de Transfermóvil.");
                return
            }
        } else if (paymentMethod === 'enz') {
            this.toggleButton();
            if (no_trans_enz === '' || no_trans_enz === undefined) {
                toastr.error("No se puede completar la reserva ya que falta el No. Transacción mediante EnZona.");
                return
            }
            if (importe_enz === '' || importe_enz === undefined || !/^\d+(\.\d{1,2})?$/.test(importe_enz)) {
                toastr.error("No se puede completar la reserva ya que falta o es inválido el importe de EnZona.");
                return
            }
        }

        // Evita acción si el botón está deshabilitado
        if (this.completeBookingTarget.classList.contains("disabled")) {
            event.preventDefault()
            event.stopPropagation()
            console.warn("No puedes completar la reserva: faltan campos.")
            toastr.error("No puedes completar la reserva: faltan campos.");
            return
        }

        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;
        let context = this;

        /*bootbox.confirm({
            message: "¿Seguro que desea completar la reserva y general la dirección de pago?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: `/admin/hotel/complete_booking`,
                        data: {},
                        type: 'POST',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })*/

        let guestsFields = "";
        // for (let i = 0; i < guestCount.split(',').length; i++) {
        $.each(guestCount.split(','), function (i, value) {
            guestsFields += `
                ${(i === 0) ? '<hr class="mt-3"><h6>Nombre y Apellidos de los Huéspedes</h6>' : ''}
                <div class="row mb-3" style="gap: .5em 0;">
                    <div class="col-md-6">
                        <input type="text" id="guest_${value}_first_name" name="guests[${value}][first_name]" placeholder="Nombre huésped ${i + 1}" class="form-control required name-input">
                    </div>
                    <div class="col-md-6">
                        <input type="text" id="guest_${value}_last_name" name="guests[${value}][last_name]" placeholder="Apellido huésped ${i + 1}" class="form-control required name-input">
                    </div>
                </div>`;
        });

        let observationsFields = "";
        $.each(roomsCount.split(','), function (i, value) {
            /*observationsFields += `
                ${(i === 0) ? '<hr class="mt-3"><h6>Observaciones</h6>' : ''}
                <div class="row mb-3" style="gap: .5em 0;">
                    <div class="col-12">
                        <input type="text" id="observation_${value}_text" name="observations[${value}][text]" placeholder="Observaciones ${i + 1}" class="form-control required name-input">
                    </div>
                </div>`;*/
            observationsFields += `
                ${(i === 0) ? '<hr class="mt-3"><h6>Observaciones</h6>' : ''}
                <div class="row mb-3" style="gap: .5em 0;">
                    <div class="col-12">
                        <textarea id="observation_${value}_text" name="observations[${value}][text]" placeholder="Observaciones ${i + 1}" class="form-control"></textarea>
                    </div>
                </div>`;
        });

        let dialog_hotel_contact_data = bootbox.dialog({
                id: 'dialog_hotel_contact_data',
                title: 'Datos de contacto del cliente',
                message: `<div style="overflow: hidden auto; max-height: 350px; text-align: justify; padding: 5px 10px;"><p class='text-danger small'>(*) Campos obligatorios</p><br>
                    <div id="hotel_contact_user_form" class="row" data-controller="country">
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_username" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['nombre']}'` : ''} type="text" placeholder="* Nombre de cliente" class="form-control required name-input"> 
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_lastname" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['apellidos']}'` : ''} type="text" placeholder="* Apellidos de cliente" class="form-control required name-input"> 
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_email" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['correo_electronico']}'` : ''} type="email" placeholder="* Correo Electrónico" class="form-control required">
<!--                         <small class="text-danger"> Para enviar la notificación y el voucher de la compra.</small> -->
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_phone_number" type="text" placeholder="Número de Teléfono" class="form-control"> 
                        </div>
                        <div class="col-12 mb-2">
                         <select id="hotel_contact_user_country_code" class="form-control"> </select>
                         <small class="text-danger"> Norma ISO de dos caracteres.</small>
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_postal_code" type="text" placeholder="Código Postal" class="form-control"> 
                        </div>
                    </div>
                    ${guestsFields}
                    ${observationsFields}
                              </div>`,
                size: 'md',
                buttons: {
                    cancel: {
                        label: "Cancelar",
                        className: 'btn-secondary'
                    },
                    ok: {
                        label: "Confirmar datos",
                        className: 'btn-success',
                        callback: function (e) {
                            let count = 0;
                            let form_required = $('#hotel_contact_user_form').find('.required');
                            form_required.map((index, element) => {
                                if (element.value.isEmpty()) {
                                    count += 1;
                                    $(element)[0].classList.remove('is-valid');
                                    $(element)[0].classList.add('is-invalid');
                                } else {
                                    $(element)[0].classList.add('is-valid');
                                    $(element)[0].classList.remove('is-invalid');
                                }
                            });

                            validate_email(document.getElementById('hotel_contact_user_email').value).then(
                                success => {
                                    if (success) {
                                        if (count > 0) {
                                            return false;
                                        } else {
                                            toastr.info('Validando datos del cliente');
                                            $('button.bootbox-close-button').trigger('click');

                                            $(`#${target}`).html(`<div style="height: 250px"></div>`);

                                            /* El beforeSend se maneja manualmente */
                                            const beforeSend = () => {
                                                console.log('Antes del envío');
                                                // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shopping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                                                // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                                                blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                                                        </svg>
                                                        ${target_message}
                                                        </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
                                            };

                                            /* Validar los nombres y apellidos de los huéspedes */
                                            let guestData = [];
                                            let validGuests = true;

                                            // for (let i = 0; i < guestCount; i++) {
                                            $.each(guestCount.split(','), function (i, value) {
                                                let firstName = document.getElementById(`guest_${value}_first_name`).value.trim();
                                                let lastName = document.getElementById(`guest_${value}_last_name`).value.trim();
                                                // Solo letras y espacios, sin números ni caracteres raros
                                                let nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;

                                                if (!firstName.match(nameRegex) || !lastName.match(nameRegex) || firstName === "" || lastName === "") {
                                                    validGuests = false;
                                                    document.getElementById(`guest_${value}_first_name`).classList.add('is-invalid');
                                                    document.getElementById(`guest_${value}_last_name`).classList.add('is-invalid');
                                                } else {
                                                    document.getElementById(`guest_${value}_first_name`).classList.remove('is-invalid');
                                                    document.getElementById(`guest_${value}_last_name`).classList.remove('is-invalid');
                                                    guestData.push({
                                                        id: value,
                                                        firstName: firstName,
                                                        lastName: lastName
                                                    });
                                                }
                                            });

                                            if (!validGuests) {
                                                toastr.error("Por favor, ingrese nombres y apellidos válidos para todos los huéspedes.");
                                                return false;
                                            }
                                            /* Validar los nombres y apellidos de los huéspedes FINN */

                                            let observData = [];
                                            /*let str_observData = {};*/
                                            let validObservs = true;
                                            $.each(roomsCount.split(','), function (i, value) {
                                                let observation = document.getElementById(`observation_${value}_text`).value.trim();
                                                // Solo letras y espacios, sin números ni caracteres raros
                                                /*let nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;*/
                                                let observacionesRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9\s,.;:()\-_!¿?@#$%&/+=*'"¡]{1,500}$/;

                                                if (!observation.match(observacionesRegex)) {
                                                    /*if (!observation.match(observacionesRegex) || observation === "") {*/
                                                    validObservs = false;
                                                    document.getElementById(`observation_${value}_text`).classList.add('is-invalid');
                                                } else {
                                                    document.getElementById(`observation_${value}_text`).classList.remove('is-invalid');
                                                    observData.push({
                                                        id: value,
                                                        text: observation
                                                    });

                                                    /*if (i === 0) {
                                                        str_observData = {
                                                            id: value,
                                                            text: observation
                                                        }
                                                    }*/
                                                }
                                            });

                                            beforeSend();
                                            post(`/admin/hotel/complete_booking`, {
                                                query: {
                                                    username: document.getElementById('hotel_contact_user_username').value,
                                                    lastname: document.getElementById('hotel_contact_user_lastname').value,
                                                    email: document.getElementById('hotel_contact_user_email').value,
                                                    phone_number: document.getElementById('hotel_contact_user_phone_number').value,
                                                    country_code: document.getElementById('hotel_contact_user_country_code').value.toLowerCase(),
                                                    postal_code: document.getElementById('hotel_contact_user_postal_code').value,
                                                    payment_method: paymentMethod,
                                                    currency_cash: currency_cash,
                                                    importe_cash: importe_cash,   // vacío si no se indicó (el controller usará totalAmount)
                                                    no_trans_tm: no_trans_tm,
                                                    importe_tm: importe_tm,
                                                    no_trans_enz: no_trans_enz,
                                                    importe_enz: importe_enz,
                                                    url_go: url_go,
                                                    ...(extraInputsFincimex || {}), /* ✅ si es null, inyecta objeto vacío y no rompe */
                                                    guests: JSON.stringify(guestData),
                                                    observations: JSON.stringify(observData)
                                                    /*observations: JSON.stringify(str_observData)*/
                                                },
                                                responseKind: "turbo-stream"
                                            }).then(r => {
                                                $('#div_filter_search_hotel').addClass('hide-tooltip');
                                                /*this.isLogin(r);
                                                this.setDealerData()*/
                                                console.log("Reserva completada satisfactoriamente.");
                                            });
                                        }
                                    } else {
                                        let email_user_form = document.getElementById('hotel_contact_user_email');
                                        email_user_form.classList.add('is-invalid');
                                        email_user_form.classList.remove('is-valid');
                                        return false;
                                    }
                                })

                            return false;
                        }
                    }
                },
                onShow: function() {
                    // Aplicar validación a los inputs recién creados
                    $('.name-input').each(function() {
                        context.restrictNameInput(this);
                    });
                }
            })
        ;
    }

    restrictNameInput(inputElement) {
        // Permite letras (mayúsculas/minúsculas), acentos, ñ, ü, espacios
        let nameRegex = /^[A-Za-záéíóúüñÁÉÍÓÚÜÑ\s]*$/;

        inputElement.addEventListener('input', function(e) {
            let originalValue = this.value;
            let cleanedValue = '';

            // Filtrar carácter por carácter
            for (let char of originalValue) {
                if (nameRegex.test(char)) {
                    cleanedValue += char;
                }
            }

            // Si se eliminaron caracteres inválidos, actualizar el input
            if (originalValue !== cleanedValue) {
                this.value = cleanedValue;
            }
        });

        // Opcional: prevenir pegar texto inválido
        inputElement.addEventListener('paste', function(e) {
            setTimeout(() => {
                let pastedValue = this.value;
                let cleanedValue = '';

                for (let char of pastedValue) {
                    if (nameRegex.test(char)) {
                        cleanedValue += char;
                    }
                }

                if (pastedValue !== cleanedValue) {
                    this.value = cleanedValue;
                }
            }, 0);
        });
    }

    confirm_booking(e) {
        let target = e.target.dataset.target;
        let payment = e.target.dataset.payment;
        let target_message = e.target.dataset.message;

        $(`#${target}`).html(`<div style="height: 250px"></div>`);

        /* El beforeSend se maneja manualmente */
        const beforeSend = () => {
            console.log('Antes del envío');
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shopping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                    </svg>
                    ${target_message}
                    </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
        };

        beforeSend();

        post(`/admin/hotel/confirm_booking`, {
            query: {
                target: target,
                payment: payment
            },
            responseKind: "turbo-stream"
        }).then(r => {
            $('#div_filter_search_hotel').addClass('hide-tooltip');
            /*this.isLogin(r);
            this.setDealerData()*/
            console.log("Reserva confirmada satisfactoriamente.");
            bootbox.alert({
                title: '<span class="text-info"><i class="fa fa-info"></i> Información</i></span>',
                message: '<div class="p-0 m-0 text-center">Reserva confirmada satisfactoriamente.</div>',
                size: 'medium',
                buttons: {
                    ok: {
                        label: "",
                        className: 'ocultar',
                    }
                }
            });
        });
    }

    cancel_booking(e) {
        let reference = e.target.dataset.reference;
        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;

        bootbox.confirm({
            title: "Cancelar",
            message: "¿Seguro que desea cancelar la reserva?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'medium',
            callback: function (result) {
                if (result) {
                    $(`#${target}`).html(`<div style="height: 250px"></div>`);

                    /* El beforeSend se maneja manualmente */
                    const beforeSend = () => {
                        console.log('Antes del envío');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shopping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                                </svg>
                                ${target_message}
                                </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
                    };

                    beforeSend();
                    post(`/admin/hotel/cancel_booking`, {
                        query: {
                            booking_reference: reference,
                            target: target
                        },
                        responseKind: "turbo-stream"
                    }).then(r => {
                        /*this.isLogin(r);
                        this.setDealerData()*/
                        console.log("Reserva Cancelada");
                    });
                }
            }
        })
    }

    other_booking() {
        post(`/admin/hotel/other_booking`, {
            query: {}
        }).then(r => {
            /*this.isLogin(r);
            this.setDealerData()*/
            console.log("Puede realizar otra Reserva.");
        });
    }

    before_send(e) {
        let target = e.target.dataset.target;
        let result = e.target.dataset.result;
        let target_message = e.target.dataset.message;

        $(`#${result}`).addClass(`show`);

        const beforeSend = () => {
            $(`#${target}`).html(`<div style="height: 250px"></div>`);

            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shopping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
              </svg>
              ${target_message}
            </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
        };

        beforeSend();
    }

    show_text_rate(e) {
        let name = e.target.dataset.name;
        let description = e.target.dataset.description;
        let conditions = e.target.dataset.conditions;

        bootbox.alert({
            title: name,
            message: `<div id="" class="row" style="overflow: hidden auto; max-height: 350px; text-align: justify; padding: 5px 10px;">
                        <div class="col-12 mb-2">
                            <h4>Descripción</h4>
                            <p>${description}</p>
                        </div>
                        <hr>
                        <div class="col-12 mb-2">
                            <h4>Condiciones</h4>
                            <p>${conditions}</p>
                        </div>
                    </div>`,
            size: 'lg',
            buttons: {
                ok: {
                    label: "Cerrar",
                    className: 'btn btn-info',
                    callback: function (e) {
                        return false;
                    }
                }
            }
        });
    }

    setRangeSeparator() {
        $('#date_range_separator').val(flatpick_lang.rangeSeparator)
    }

    filterByRate(event) {
        const distId = event.target.dataset.distId;
        this._applyFiltersAndSort(event.target.value, distId);
    }

    sortByPrice(event) {
        const distId = event.target.dataset.distId;
        const rateFilter = this.rateFilterTargets.find(el => el.dataset.distId === distId);
        const selectedCode = rateFilter ? rateFilter.value : "";
        this._applyFiltersAndSort(selectedCode, distId);
    }

    _applyFiltersAndSort(selectedCode, distId) {
        const container = this.roomOptionsContainerTargets.find(el => el.dataset.distId === distId);
        if (!container) return;

        const cards = Array.from(container.querySelectorAll(".room-option-card"));
        const priceSortEl = this.priceSortTargets.find(el => el.dataset.distId === distId);
        const sortDir = priceSortEl ? priceSortEl.value : "asc";

        const matchingCards = cards
            .filter(card => selectedCode && card.dataset.rateCode === selectedCode)
            .sort((a, b) => {
                const diff = parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
                return sortDir === "desc" ? -diff : diff;
            });

        // Ocultar todas primero
        cards.forEach(card => card.style.display = "none");

        // Reordenar en el DOM y mostrar
        matchingCards.forEach(card => {
            container.appendChild(card);
            card.style.display = "";
        });

        // ✨ Animación de entrada escalonada
        matchingCards.forEach((card, i) => {
            card.style.opacity = "0";
            card.style.transform = "translateY(16px)";
            card.style.transition = `opacity 0.3s ease ${i * 0.06}s, transform 0.3s ease ${i * 0.06}s`;
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    card.style.opacity = "1";
                    card.style.transform = "translateY(0)";
                });
            });
        });

        if (matchingCards.length > 0) {
            const navbarOffset = 350; // compensa el sticky navbar (~70px + margen)
            const cardTop = matchingCards[0].getBoundingClientRect().top + window.scrollY - navbarOffset;
            window.scrollTo({ top: cardTop, behavior: "smooth" });
        }
    }

    togglePhotos(event) {
        const btn = event.currentTarget;
        const carouselId = btn.dataset.carouselId;
        const carousel = document.getElementById(carouselId);
        const count = btn.dataset.photosCount;
        const isHidden = carousel.classList.contains("d-none");

        if (isHidden) {
            carousel.querySelectorAll("img[data-src]").forEach(img => {
                if (!img.getAttribute("src")) {
                    img.src = img.dataset.src;
                }
            });
            carousel.classList.remove("d-none");
            btn.innerHTML = `<i class="fa fa-eye-slash mr-1"></i> Ocultar fotos`;
        } else {
            carousel.classList.add("d-none");
            btn.innerHTML = `<i class="fa fa-camera mr-1"></i> Ver fotos (${count})`;
        }
    }

    // ========== NUEVOS MÉTODOS PARA FILTROS DEPENDIENTES ==========
    loadAreas() {
        const regionId = this.locationRegionTarget.value

        get(`/admin/hotel/areas?region_id=${regionId}`, {
            query: {
                target: 'location_area'
            },
            responseKind: "turbo-stream"
        }).then(r => {
            $(this.locationAreaTarget).removeAttr('disabled');
            setTimeout(() => {
                this.loadZones();
                this.loadHotelsByLocation();
            }, 1000)
        });
    }

    loadZones() {
        const areaId = this.locationAreaTarget.value

        get(`/admin/hotel/zones?area_id=${areaId}`, {
            query: {
                target: 'location_zone'
            },
            responseKind: "turbo-stream"
        }).then(r => {
            $(this.locationZoneTarget).removeAttr('disabled');
            setTimeout(() => {
                this.loadHotelsByLocation();
            }, 500)
        });

        /*if (areaId && this.locationAreaTarget.disabled === false) {
            this.resetSelect(this.locationZoneTarget)
            this.resetHotelSelect()
            this.locationZoneTarget.disabled = true

            fetch(`/admin/hotel/zones?area_id=${areaId}`, {
                headers: { "Accept": "text/vnd.turbo-stream.html" }
            })
                .then(response => response.text())
                .then(html => {
                    this.locationZoneTarget.innerHTML = html
                    this.locationZoneTarget.disabled = false
                })
                .catch(error => console.error("Error loading zones:", error))
        } else {
            this.resetSelect(this.locationZoneTarget)
            this.resetHotelSelect()
            this.locationZoneTarget.disabled = true
        }*/
    }

    loadHotelsByLocation() {
        const vendorCode = this.vendorCodeTarget.value
        const regionId = this.locationRegionTarget.value
        const areaId = this.locationAreaTarget.value
        const zoneId = this.locationZoneTarget.value

        // Construir URL con los parámetros presentes
        let url = '/admin/hotel/hotels?'
        const params = []
        if (vendorCode) params.push(`vendor_code=${vendorCode}`)
        if (regionId) params.push(`region_id=${regionId}`)
        if (areaId) params.push(`area_id=${areaId}`)
        if (zoneId && this.locationZoneTarget.disabled === false) params.push(`zone_id=${zoneId}`)

        if (params.length === 0) {
            // Si no hay filtros, cargar todos los hoteles activos
            url = '/admin/hotel/hotels?all=true'
        } else {
            url += params.join('&')
        }

        get(url, {
            query: {
                target: 'hotel_id'
            },
            responseKind: "turbo-stream"
        }).then(r => {

        })
    }

    resetSelect(selectElement) {
        if (!selectElement) return
        const prompt = selectElement.querySelector('option[value=""]')?.text || "Seleccionar"
        selectElement.innerHTML = `<option value="">${prompt}</option>`
    }

    resetHotelSelect() {
        if (!this.hasHotelSelectTarget) return
        const prompt = this.hotelSelectTarget.querySelector('option[value=""]')?.text || "Seleccionar hotel"
        this.hotelSelectTarget.innerHTML = `<option value="">${prompt}</option>`
        this.hotelSelectTarget.disabled = true
    }
}
